import { BomItemPointer } from 'model/Project/BomItemPointer'
import { BoMItemActivityDto } from 'services/APIs/InternalAPI/internal-api.contracts'
import { RootAppState } from 'store/configureStore'
import { bomItemAllActivitiesSelector } from './allBomItemActivitiesSelector'

export const bomItemActivityByArticleIdSelector =
  (bomItemPointer: BomItemPointer, articleId: string) =>
  (state: RootAppState): BoMItemActivityDto | undefined => {
    if (!articleId) {
      return null
    }

    const bomItemActivities =
      bomItemAllActivitiesSelector(bomItemPointer)(state)

    return bomItemActivities.find(
      (activity) => activity.article?.id === articleId
    )
  }
